import {combineReducers} from "@reduxjs/toolkit"
import assignment from "./assignment-slice"
import report from "./report-slice"

const costs = combineReducers({
    assignment, report
})
export default costs
